import React from 'react'
import ReactDOMServer from 'react-dom/server';
import moment from 'moment'
import {inWords} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'


const TableCustomPadding = (props) => {

  let pad = props.spacing || 20
  pad = pad + 'px;'

  return (<style>
      {".preview-a4 .table>tbody>tr>td, .preview-a4 .table>thead>tr>th { padding: "+pad+"} .preview-a4 .space-small{margin-top:5px;}.preview-a4 .table-thin>tbody>tr>td{padding:5px;} .preview-a4 .table-thin { width:100%;}"}
  </style>)
}




class SpacingHandler extends React.Component {

  render() {
    return <div >Table Spacing <input type="range" style={{maxWidth:150}}  defaultValue={20}
      min={0} max={30}
      ref="tableSpacing" onChange={(e)=>{
        this.props.handleTableSpacing(e, this.refs.tableSpacing.value)
      }}></input></div>

  }
}


export default class PreviewTrader2 extends React.Component {

  constructor(props){
    super(props)
    this.state = {tableSpacing:20}
  }

  handleTableSpacing = (e, v)=>{
    this.setState({tableSpacing:v})
  }

  render() {

    let company = this.props.company
    let invoice = this.props.invoice
    let settings = this.props.settings || getUserSettings()
    let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
    let invoice_date = moment(invoice.date).format('D-MMM-YYYY')
    let billto_1, billto_2, billFrom
    let place_of_supply
    let shipping_address
    let optionalRow = false
    let table_cols = 6
    let invoice_label = "INVOICE"
    let roundOffValue

    let letterpadPadding = 180
    let letterpad_header

    if(this.props.show_letterpad_header) {
      letterpadPadding = 40
      letterpad_header = <div className="text-center" style={{marginBottom:40}}>
        <div className="company-name text-uppercase">
          {company.company_name}
        </div>
        <div className="row">
          <div className="col-xs-8 col-xs-offset-2">
             {company.address} {company.city} {company.state} {company.pin}
          </div>
        </div>
      </div>
    }


    let serial = invoice.series_name + invoice.series_counter

    if(document) {
      const s = ReactDOMServer.renderToStaticMarkup(serial)
      document.title = s
    }

    let header = <div className="row">
      <div className="col-xs-8">
        <div style={{fontSize:'120%'}}><strong>{serial}</strong></div>
      </div>
      <div className="col-xs-4 text-right">Date: <strong>{invoice_date}</strong></div>
    </div>


    let client_name = invoice.client ? invoice.client.name : ""
    let client_address = invoice.client ? invoice.client.address + " " + invoice.client.city + " " +invoice.client.state : ""
    let client_phone = invoice.client ? invoice.client.phone:""
    let additional_params = invoice.client ? invoice.client.additional_params: undefined
    let age, gender, age_gender = ""

    if(additional_params) {
      age = additional_params.find(param=>param.key.toLowerCase()=="age")
      if(typeof age !== "undefined" && age !== null) {
        age_gender = age_gender + age.value

      }
      gender = additional_params.find(param=>param.key.toLowerCase()=="gender")
      if(typeof gender !== "undefined" && gender !== null) {
        age_gender  = age_gender + '/' + gender.value
      }

      age_gender = <span>Age/Gender: <strong>{age_gender}</strong></span>
    }

    let invoice_additional_params = invoice.additional_params

    let claim_no, healthcard_no, treating_doctor, doa, dos, dod, IPNo
    if(typeof invoice_additional_params !== "undefined" && invoice_additional_params !== null) {
       claim_no = invoice_additional_params.find(param=>param.key.toLowerCase()=="claim no")
      if(typeof claim_no !== "undefined" && claim_no !== null) {
        claim_no = <span>Claim No: <strong>{claim_no.value}</strong></span>
      }
      healthcard_no = invoice_additional_params.find(param=>param.key.toLowerCase()=="healthcard no")
     if(typeof healthcard_no !== "undefined" && healthcard_no !== null) {
       healthcard_no = <span>Healthcard No: <strong>{healthcard_no.value}</strong></span>
     }
     treating_doctor = invoice_additional_params.find(param=>param.key.toLowerCase()=="treating doctor")
    if(typeof treating_doctor !== "undefined" && treating_doctor !== null) {
      treating_doctor = <span>Treading Doctor: <strong>{treating_doctor.value}</strong></span>
    }
    doa = invoice_additional_params.find(param=>param.key.toLowerCase()=="doa")
   if(typeof doa !== "undefined" && doa !== null) {
     doa = <tr><td className="text-left">D.O.A</td><td><strong>{doa.value}</strong></td></tr>
   }
   dos = invoice_additional_params.find(param=>param.key.toLowerCase()=="dos")
  if(typeof dos !== "undefined" && dos !== null) {
    dos = <tr><td className="text-left">D.O.S</td><td><strong>{dos.value}</strong></td></tr>
  }
  dod = invoice_additional_params.find(param=>param.key.toLowerCase()=="dod")
 if(typeof dod !== "undefined" && dod !== null) {
   dod = <tr><td className="text-left">D.O.D</td><td><strong>{dod.value}</strong></td></tr>
 }
 IPNo = invoice_additional_params.find(param=>param.key.toLowerCase()=="ip no")
if(typeof IPNo !== "undefined" && IPNo !== null) {
  IPNo = <tr><td className="text-left">IPNO</td><td ><strong>{IPNo.value}</strong></td></tr>
}

    }





    let client = <div className="row" style={{marginTop:35}}>
      <div className="col-xs-9">
        <div>Name: <strong>{client_name}</strong></div>
        <div className="space-small">{age_gender}</div>
        <div className="space-small">Phone: {client_phone}</div>
        <div className="space-small">Address: {client_address}</div>
        <div className="space-small">{claim_no}</div>
        <div className="space-small">{healthcard_no}</div>
        <div className="space-small">{treating_doctor}</div>
        </div>
        <div className="col-xs-3 text-right">
          <table className="table-thin" style={{border:"1px solid #ddd"}}>
            <tbody>
              {doa}{dos}{dod}{IPNo}
            </tbody>
          </table>
        </div>
    </div>




let itemsHeader = <thead>
  <tr className="active">
    <th style={{maxWidth:25}}>S.No</th>
    <th className="table-item">Particulars</th>
    <th className="text-center">Units</th>
    <th className="text-right">Rate</th>
    <th className="table-item text-right">Amount</th>
  </tr>
</thead>


let items, summaryRow, total_amount = 0
if(invoice.saleitem_set.length > 0) {

  invoice.saleitem_set.sort((a,b)=>{
    return a.tableIndex - b.tableIndex
  })

  items = invoice.saleitem_set.map((saleitem, index)=>{
    let discountCol, cgstcol, sgstcol, igstcol

    let unit_price = parseFloat(saleitem.selling_basic_rate).toFixed(2),
    taxable_price = parseFloat(saleitem.price).toFixed(2),
    item_total = parseFloat(saleitem.total).toFixed(2)

    total_amount = total_amount + parseFloat(saleitem.total)

    return <tr key={index}>
      <td>{saleitem.tableIndex}</td>

      <td>
      <div>{saleitem.name}</div>
      <div>{saleitem.description}</div>
      </td>
      <td className="text-center">{Number(saleitem.quantity)}</td>
      <td className="text-right">{unit_price}</td>


      <td className="text-right"><div>{parseFloat(item_total).toFixed(2)}</div></td>
  </tr>
  })
}

items.push(<tr key="summaryRow">
            <td colSpan={3}></td>
            <td className="text-right" style={{fontSize:'120%'}}>TOTAL</td>
            <td className="text-right" style={{fontSize:'120%'}}>{parseFloat(total_amount).toFixed(2)}</td></tr>)

let Signaturerow = <div className="row" style={{marginTop:100}}>
  <div className="col-xs-12 text-right">
    Authorized Signature
  </div>
</div>

    return <div>
      <SpacingHandler handleTableSpacing={this.handleTableSpacing} />

        <div className="preview-a4 container" style={{paddingTop:letterpadPadding}}>

          <TableCustomPadding spacing={this.state.tableSpacing} />
          {letterpad_header}
              {header}
              {client}

              <table className="table table-bordered" style={{marginTop:35}}>
              {itemsHeader}
              <tbody>

              {items}

              </tbody>
              </table>
              {Signaturerow}
        </div>

    </div>




  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/previewSimpleServiceLetterPad.js